import Vue from 'vue';

Vue.filter('substring', (value, number = 50) => {
  if (!value) return '';
  return value.substr(0, number);
});

Vue.filter('empty', value => value || '-');



// WEBPACK FOOTER //
// ./src/filters/index.js